<template>
    <div class="site-main">
    	<div class="article" v-if="flag">
    		<p class="s-results">共搜索到<span>{{total}}</span>条</p>
    		<list :items="events" class="mt20 mb20 b-shadow"></list>
    		<infinite-loading @infinite="onInfinite" ref="infiniteLoading">
	      		<!-- <loading slot="spinner"></loading> -->
	      		<span slot="no-more">我是有底线的</span>
	    	</infinite-loading>
    	</div>
    	<div v-else class="search-no"><img src="../common/images/s-no.png" alt="没有搜索到内容"></div>
    </div>
</template>

<script>
import {httpHead,apiUrl} from '../common/util/config.js';
import List from '../components/List.vue'
import InfiniteLoading from 'vue-infinite-loading'
export default {
    data () {
        return {
        	key: '',
        	events:[],
        	page: 0,
        	totalPage: 0,
        	flag: true,
        	total: 0 
        }
    },
    created () {
    	this.key = this.$route.params.keyword
    },
    methods: {
    	onInfinite ($state) {
    		let postData = this.$qs.stringify({
			    'keyword': this.key,
			});
			this.page++;
			let url = apiUrl+'api/lists/page/'+this.page
    		this.$axios({
    			method: 'post',
			    url: url,
			    headers: httpHead,
			    data:postData
    		})
	        	.then(res => {
	        		this.totalPage = res.data.data.list.last_page;
	                this.events = this.events.concat(res.data.data.list.data);
	                this.total = res.data.data.list.total;
	                if(this.events.length == 0){
	                	this.flag = false;
	                }
	                $state.loaded();
	                if(this.totalPage == this.page){
	                	$state.complete()
	                }
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                    $state.complete()
	                }
	            })
	    }
    },
    watch: {
    	'$route' (to, from) {
    		this.flag = true;
		 	this.key = this.$route.params.keyword
		 	this.page = 0;
    		this.events = [];
    		this.$nextTick(() => {
		        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		    });
		}
    },
    components: {
    	List,
    	InfiniteLoading
    }
}
</script>
<style lang="scss">
	.search-no {
		padding: 2.5rem 1rem; 
		min-height: 5rem;
	}
	.s-results{
		padding:0 .3rem;
		margin-top: .2rem;
		span{
			color:#f50;
			margin:0 .1rem;
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/searchView.vue